(function (root) {
  'use strict';
  function create(options) {
    var read = options.read;
    var write = options.write;
    var handle = options.warrantyHandle;
    var variant = Number(options.warrantyVariantId);
    var attempts = options.attempts || 3;
    function isWarranty(item) {
      return item.handle === handle || item.product_handle === handle || Number(item.variant_id || item.id) === variant;
    }
    function isJuicer(item) {
      return (item.handle || item.product_handle) === 'cold-press-juicer' || /\/products\/cold-press-juicer(?:[/?#]|$)/.test(item.url || '');
    }
    function lineIdentity(item) {
      var id = item && (item.variant_id || item.id);
      var allocation = item && item.selling_plan_allocation;
      var plan = allocation && allocation.selling_plan && allocation.selling_plan.id;
      var properties = item && item.properties;
      if (!/^\d+$/.test(String(id || '')) || (allocation && !/^\d+$/.test(String(plan || ''))) ||
          (properties != null && (typeof properties !== 'object' || Array.isArray(properties)))) {
        throw new Error('The requested cart item could not be identified. Review your cart before continuing.');
      }
      return JSON.stringify([String(id), plan ? String(plan) : null, Object.keys(properties || {}).sort().map(function (name) {
        return [name, properties[name]];
      })]);
    }
    function quantityTarget(item, cart) {
      if (!item || !item.key) throw new Error('The requested cart item could not be identified. Review your cart before continuing.');
      // Freeze every property, including private properties. Discount applications may change the key, not this identity.
      var identity = lineIdentity(item);
      var unique = Boolean(cart && Array.isArray(cart.items) && cart.items.filter(function (line) { return lineIdentity(line) === identity; }).length === 1);
      return { key: item.key, identity: identity, allowKeyChange: unique };
    }
    function quantityItem(cart, target, quantity) {
      inspect(cart);
      if (!target || !target.key || !target.identity || !Number.isInteger(quantity) || quantity < 0) throw new Error('The requested quantity could not be confirmed. Review your cart before continuing.');
      var exact = cart.items.filter(function (line) { return line.key === target.key; });
      if (exact.length > 1) throw new Error('The requested quantity could not be confirmed. Review your cart before continuing.');
      if (!exact.length && !target.allowKeyChange) throw new Error('The requested quantity could not be confirmed. Review your cart before continuing.');
      var matches = exact.length ? exact : cart.items.filter(function (line) { return lineIdentity(line) === target.identity; });
      if (quantity === 0 ? matches.length !== 0 : matches.length !== 1 || lineIdentity(matches[0]) !== target.identity || matches[0].quantity !== quantity) {
        throw new Error('The requested quantity could not be confirmed. Review your cart before continuing.');
      }
      return matches[0] || null;
    }
    function inspect(cart) {
      if (!cart || !Array.isArray(cart.items) || !Number.isInteger(cart.total_price) || cart.total_price < 0 || !cart.currency) throw new Error('The cart could not be verified.');
      var quantity = 0, juicers = 0, lines = [], updates = {};
      cart.items.forEach(function (item) {
        if (!Number.isInteger(item.quantity) || item.quantity < 1 || !item.key || !Number.isInteger(item.final_line_price) || item.final_line_price < 0) throw new Error('The cart items could not be verified.');
        quantity += item.quantity;
        if (isWarranty(item)) {
          lines.push(item);
          if (item.final_line_price !== 0) throw new Error('The included warranty price could not be verified.');
        } else if (isJuicer(item)) juicers += item.quantity;
      });
      if (cart.item_count !== quantity) throw new Error('The cart quantity could not be verified.');
      if (juicers && (!handle || !variant)) throw new Error('The included warranty is unavailable.');
      var wanted = juicers > 0 ? 1 : 0;
      lines.forEach(function (line, index) {
        var next = index === 0 ? wanted : 0;
        if (line.quantity !== next) updates[line.key] = next;
      });
      if (!lines.length && wanted) updates[variant] = 1;
      return { cart: cart, updates: updates, valid: Object.keys(updates).length === 0 };
    }
    function signature(cart) {
      return JSON.stringify({currency: cart.currency, total: cart.total_price, items: cart.items.map(function (item) {
        return [item.key, item.quantity, item.final_line_price];
      }).sort(function (a, b) { return a[0].localeCompare(b[0]); })});
    }
    function productSignature(cart) {
      var products = cart.items.filter(function (item) { return !isWarranty(item); });
      var identities = products.map(lineIdentity);
      return JSON.stringify({ currency: cart.currency, total: cart.total_price, items: products.map(function (item, index) {
        var identity = identities[index];
        var unique = identities.indexOf(identity) === identities.lastIndexOf(identity);
        return [identity, unique ? null : item.key, item.quantity, item.final_line_price];
      }).sort(function (a, b) { return JSON.stringify(a).localeCompare(JSON.stringify(b)); }) });
    }
    function reconcile(expected) {
      var remaining = attempts;
      var expectedProducts = expected ? productSignature(expected) : null;
      function run() {
        remaining -= 1;
        return read().then(function (cart) {
          var state = inspect(cart);
          if (expectedProducts !== null && productSignature(cart) !== expectedProducts) throw new Error('The cart changed. Review the updated quantities before continuing.');
          if (state.valid) return cart;
          return write(state.updates).then(function () { return read(); }).then(function (verified) {
            var result = inspect(verified);
            if (!result.valid || productSignature(verified) !== productSignature(cart) || verified.currency !== cart.currency || verified.total_price !== cart.total_price) throw new Error('The included warranty could not be confirmed.');
            return verified;
          });
        }).catch(function (error) {
          if (remaining > 0 && (!error.status || error.status === 429 || error.status >= 500)) return run();
          throw error;
        });
      }
      return run();
    }
    return { inspect: inspect, reconcile: reconcile, signature: signature, quantityTarget: quantityTarget, quantityItem: quantityItem };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = create;
  else root.HeartnoksCartIntegrity = create;
})(typeof window !== 'undefined' ? window : globalThis);
